import { useEffect } from 'react';

export default function AboutSchema() {
  useEffect(() => {
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '51漫画网',
        url: 'https://51manhua.com/',
        description: '51漫画网创立于2018年，专注韩国漫画中文在线阅读，提供无删减高清韩漫下拉式阅读服务',
        foundingDate: '2018',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '关于我们 - 51漫画网',
        url: 'https://51manhua.com/about',
        description: '了解51漫画网品牌故事、平台声誉和联系方式',
        isPartOf: {
          '@type': 'WebSite',
          name: '51漫画网',
          url: 'https://51manhua.com/',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'https://51manhua.com/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '关于我们',
          },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '51漫画网是什么平台？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '51漫画网是一个专注于韩国漫画的中文在线阅读平台，提供无删减、高清画质的韩漫资源。自2018年上线以来，已累计服务超过500万忠实用户。',
            },
          },
          {
            '@type': 'Question',
            name: '为什么选择51漫画网？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '第一，无删减内容；第二，下拉式阅读无需翻页；第三，更新及时与韩国同步；第四，资源丰富超过10,000部韩漫。',
            },
          },
          {
            '@type': 'Question',
            name: '如何联系我们？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过页脚的邮箱订阅与我们保持联系。如有商务合作、版权问题或其他事宜，欢迎发送邮件至官方邮箱，团队会在1-3个工作日内回复。',
            },
          },
          {
            '@type': 'Question',
            name: '51漫画网是否需要付费？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '51漫画网目前提供完全免费的韩漫阅读服务，所有漫画内容均可免费在线阅读。',
            },
          },
        ],
      },
    ];

    const scriptId = 'schema-org-about';
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemas, null, 2);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, []);

  return null;
}